























































import { helpers, required, requiredIf, maxLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';

export default {
	name: 'MakeOfferJobDetails',

	setup() {
		const form = ref({
			job: '',
			candidate: '',
			start_date: null,
			end_date: null,
		});

		const edit = ref(false);

		const loading = ref(false);

		return { form, edit, loading };
	},

	computed: {
		...mapGetters('offerModule', {
			dates: 'getDates',
		}),

		...mapGetters('jobs/single', {
			job: 'getSingleJob',
		}),

		...mapGetters('applications', {
			candidate: 'getApplicant',
		}),

		jobDates() {
			return JSON.parse(JSON.stringify(this.dates));
		},
	},

	mounted() {
		this.populateData();
	},

	methods: {
		submit() {
			if (this.edit) {
				this.toggleEdit();
				this.updateJobDetails();
			} else {
				this.updateJobDetails();
				this.$store.dispatch('offerModule/setCurrentStep', 2);
			}
		},
		toggleEdit() {
			this.edit = !this.edit;
		},

		cancel() {
			if (this.edit) {
				this.populateData();
				this.toggleEdit();
			} else {
				this.$emit('close');
			}
		},

		populateData() {
			this.form.job = this.job.title;
			this.form.candidate = `${this.candidate.name} ${this.candidate.surname}`;
			this.form.start_date = this.jobDates?.start_date ? this.jobDates.start_date : this.job.start_date;
			this.form.end_date = this.jobDates?.end_date ? this.jobDates.end_date : this.job.end_date;

			this.updateJobDetails();
		},

		updateJobDetails() {
			this.$store.dispatch('offerModule/updateDates', {
				start_date: this.form.start_date,
				end_date: this.form.end_date,
			});
		},
	},
};
